import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PanelNavigator.css';

const PanelNavigator = ({ text, path }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current path

  const stateChange = (e) => {
    e.preventDefault();
    navigate(path, { replace: true }); // Navigate to the given path
  };

  // Check if the current path matches the panel's path
  const isActive = location.pathname === path;

  return (
    <div
      style={isActive ? {
        background: '#F9FAFB', borderRadius: '0.5rem', cursor: 'pointer',
      } : {
        background: '#FFFFFF', cursor: 'pointer',
      }}
      onClick={stateChange}
    >
      <div className="panelNavigator-container" style={{fontFamily: 'Inter'}}>{text}</div>
    </div>
  );
};

export default PanelNavigator;
